import { useContext, useState } from 'react';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css'
import { useHistory } from 'react-router-dom';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import { redirecturlQueryParam } from '../../app/constants/constants';
import { useAppDispatch, useAppSelector } from '../../app/store/hooks';
import useURLQuery from '../../hooks/useURLQuery';
import { ErrorManagementContext } from '../../utils/errorManagement/ErrorManagementProvider';
import { UplianceLogo } from '../../utils/iconRefs/authIcons';
import { logEvents } from '../../utils/logging';
import { setPhoneNumber } from './auth.slice';
import { phoneNumberSubmit } from './auth.thunk';
import styles from "./loginWithPhone.module.css";

const LoginWithPhone = () => {

  const dispatch = useAppDispatch();

  const history = useHistory()

  const searchParams = useURLQuery();

  const { cookClubLog } = useContext(ErrorManagementContext);

  const phoneNumber = useAppSelector(state => state.auth.otpLogin.phone);
  const isPhoneNumberSubmitLoading = useAppSelector(state => state.auth.loaders.isPhoneNumberSubmitLoading);

  const [isSubmitButtonActive, setIsSubmitButtonActive] = useState(false)

  const redirecturl = searchParams.get(redirecturlQueryParam);

  const handleSend = async () => {
    logEvents('null', 'APP_OTP_LOGIN_INITIALIZED', {
      userId: null,
    })
    if (phoneNumber) {
      dispatch(phoneNumberSubmit({ phoneNumber, redirecturl, history, cookClubLog }))
    }
  }

  const handlePhoneChange = (countryData: CountryData, formattedNumber: string) => {
    const splitPhoneNumber = formattedNumber.split(' ')
    if (splitPhoneNumber.length > 1) {
      const phoneWithoutCountryCode = splitPhoneNumber[1]
      if (countryData?.countryCode === 'in' && phoneWithoutCountryCode.length === 10) setIsSubmitButtonActive(true)
      else if (countryData?.countryCode !== 'in' && phoneWithoutCountryCode.length > 1) setIsSubmitButtonActive(true)
      else setIsSubmitButtonActive(false)
    }
    dispatch(setPhoneNumber(formattedNumber))
  }

  return (
    <div className={styles.main_container}>
      <UplianceLogo />
      <div className={styles.login_form_input_container}>
        <Typography variant='h6' >Let&apos;s get started!</Typography>
        <PhoneInput
          alwaysDefaultMask
          copyNumbersOnly={false}
          country='in'
          defaultMask='............'
          dropdownStyle={{
            scrollbarWidth: 'thin',
            width: '326px',
            minHeight: '400px',
          }}
          inputStyle={{ width: '100%' }}
          onChange={(phoneData, countryCodeData: CountryData, event, formattedString) => handlePhoneChange(countryCodeData, formattedString)}
          specialLabel=''
          value={phoneNumber}
        />
        <Button
          className={isSubmitButtonActive ? styles.submit_btn : styles.disabled_submit_btn}
          disabled={!isSubmitButtonActive}
          onClick={handleSend}
        >
          <Typography variant='caption3Light'>Get OTP</Typography>
          {isPhoneNumberSubmitLoading && <div className={styles.phone_login_loading_container}><CircularProgress className={styles.circular_loader} size={17} /></div>}
        </Button>
        <div id="recaptcha" /> {/* This is where the reCAPTCHA widget will be rendered */}
      </div>
    </div>
  )
}

export default LoginWithPhone